import { Checkbox, FormControlLabel } from "@material-ui/core";

export const CustomCheckbox = ({ label, ...rest }) => {
  return <FormControlLabel control={<Checkbox {...rest} />} label={label} />;
};
